<template>
  <div class="container">
    <!--用户成就-->
    <achievement-info v-if="loginState" ref="achieveRef" :save-price="achieveSavePrice" :achieve-data="achieveData" @tiggerAchieve="tiggerAchieve" @shareNow="shareClick"> </achievement-info>
    <!-- 未登录模块 -->
    <no-login-head v-else @goRegister="goRegister"></no-login-head>
    <div
      :class="{
        'my-info-box': true
      }"
    >
      <!-- 用户信息 -->
      <new-user-info
        v-if="loginState"
        :userInfo="userInfo"
        :wait-get-free-card="waitGetFreeCard"
        @goUserInfo="enterUserInfo"
        @userLevel="goUpgrade"
        @freeCard="freeCardCenter"
        @violationTagClick="violationTagClick"
      >
      </new-user-info>
      <!-- <user-info-tmpl
        v-if="loginState"
        :userInfo="userInfo"
        :wait-get-free-card="waitGetFreeCard"
        @goUserInfo="goUserInfo"
        @userLevel="goUpgrade"
        @freeCard="freeCardCenter"
        @violationTagClick="violationTagClick"
      >
      </user-info-tmpl> -->
      <!-- 升级引导 -->
      <upgrade-guide v-if="loginState && userInfo.UserLevel && userInfo.UserLevel !== 3" :user-info="userInfo" @checkDetail="goUpgrade" @upLevel="goUpgrade"> </upgrade-guide>
      <!-- 我的订单tab -->
      <order-tab
        :wait-finish-badge="waitFinishBadge"
        :wait-receive-badge="waitReceiveBadge"
        :wait-evaluate-badge="waitEvaluateBadge"
        @entoMyOrder="entoMyOrder"
        @entoHasRefund="entoHasRefund"
        @invitationEvaluate="invitationEvaluate"
      >
      </order-tab>
      <!-- 合伙人 -->
      <div class="my-partner" v-if="loginState && isPartnerShow">
        <mt-cell title="搜货合伙人" is-link @click.native="entoPartner"> </mt-cell>
        <div class="my_tabs_partner" @click="entoPartner">
          <img :src="youpPath + partnerBanner" class="partner_img" />
        </div>
      </div>
      <!-- 我的服务 -->
      <service-tab-list
        v-if="loginState"
        :recommend-cards="recommendCards"
        :is-show-rank="isShowRank"
        :rank-free-carts="rankFreeCarts"
        :userInfo="userInfo"
        @entoAmount="entoAmount"
        @balanceWithDraw="balanceWithDraw"
        @shareClick="shareClick"
        @recommendRank="recommendRank"
        @platformProtocol="platformProtocol"
        @rebateNote="rebateNote"
        @waitHandler="waitHandler"
        @violationPage="violationPage"
        @contactCs="contactCs"
        @makeComplaints="makeComplaints"
        @helpAndFeedback="helpAndFeedback"
        @aboutUs="aboutUs"
        @enterUserInfo="enterUserInfo"
        @enterRemindSetting="enterRemindSetting"
      >
      </service-tab-list>
      <div class="emptyBoxOfRabbar"></div>
    </div>
    <!-- 弹窗 -->
    <sh-icon-dialog
      v-if="limitDialogShow"
      msg="请点击下方按钮查看原因，如有疑问请联系客服"
      :show-cancel-btn="true"
      tip="提现被限制"
      cancel-text="联系客服"
      confirm-text="查看原因"
      @cancel="contactCs"
      @confirm="goViolationPage()"
    >
    </sh-icon-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { SaleMiniAppMyInfoGet, GetRecommendSendQty, GetMemberAchievementsInfo, OnClickLimitCheck } from '@/api/my'
import { IMG_BASE_URL } from '@/config/index'
import ShIconDialog from '@/components/puppetComponent/ShIconDialog'
import AchievementInfo from './children/AchievementInfo'
import NoLoginHead from './children/NoLoginHead'
import UserInfoTmpl from './children/UserInfo'
import UpgradeGuide from './children/UpgradeGuide'
import OrderTab from './children/OrderTab'
import ServiceTabList from './children/ServiceTabList'
import NewUserInfo from './children/NewUserInfo'

export default {
  name: 'my',
  data() {
    return {
      userInfo: {},
      achieveData: {},
      achieveIsOpen: false, // 成就是否展开
      achieveSavePrice: 0, // 用户累计返利金额
      isFetch: false, // 获取成就数据开关
      waitFinishBadge: 0,
      waitReceiveBadge: 0,
      waitEvaluateBadge: 0,
      recommendCards: 0,
      youpPath: IMG_BASE_URL,
      isPartnerShow: false, // 合伙人
      isShowRank: false, // 推荐排行
      rankFreeCarts: 0, // 推荐排行免单卡数
      hasGetFreeCard: 0, // 已领取但未使用的免单卡数量
      waitGetFreeCard: 0, // 待领取免单卡数量
      userIsLimit: false, // 用户是否被限制
      limitDialogShow: false, // 限制弹窗显示
      // limitDays: 0, // 限制天数
      // limitDate: '', // 解除限制的日期
      // isBuyLimit: false, // 限制购买
      // limitBuyDays: 0, // 限制购买天数
      // limitBuyDate: '', // 解除限制购买的日期
      partnerBanner: '/upaiyun/Sys/20180813/5461726565089348091.png'
    }
  },
  components: {
    AchievementInfo,
    NoLoginHead,
    UserInfoTmpl,
    UpgradeGuide,
    OrderTab,
    ServiceTabList,
    ShIconDialog,
    NewUserInfo
  },
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized'])
  },
  beforeCreate() {
    Indicator.close()
  },
  watch: {
    loginState() {
      this.reFetchPage('userInfo')
    }
  },
  methods: {
    ...mapMutations(['TAB_BAR_MY_BADGE', 'SET_PORTRAIT_URL', 'AUTHORIZE_POPUP_SHOW']),
    ...mapActions(['loginOut', 'updateNotificationAuthorized']),
    reFetchPage(from) {
      if (this.getIsApp) {
        this.updateNotificationAuthorized()
      }
      let routeNames = ['userInfo', 'posterDetail', 'rebateNote', 'platformProtocol']
      if (routeNames.indexOf(from.name) !== -1) {
        // do nothing
      } else {
        this.isFetch = false
        if (this.loginState) {
          this.fetchData()
          this.fetchRecommendCards()
          this.$store.dispatch('waitGetFreeCarNum_Action')
        }
      }
    },
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      SaleMiniAppMyInfoGet()
        .then((res) => {
          Indicator.close()
          let data = (this.userInfo = res.SaleMiniAppMyInfo)
          this.waitFinishBadge = parseInt(data.WaitFinishCount)
          this.waitReceiveBadge = parseInt(data.WaitReceiveCount)
          this.waitEvaluateBadge = parseInt(data.WaitEvaluateOrderCount)
          this.isShowRank = data.IsOffWeekRecommendRank
          this.rankFreeCarts = data.WeekRecommendRankNo1
          this.hasGetFreeCard = data.GetQtyNoUsed
          this.waitGetFreeCard = data.WaitGetQty
          this.userIsLimit = data.IsTALimit
          // this.limitDays = data.LimitDayNumber
          // this.limitDate = data.TALimitRemoveDate
          // this.isBuyLimit = data.IsBuyLimit
          // this.limitBuyDays = data.BuyLimitDayNumber
          // this.limitBuyDate = data.BuyLimitRemoveDate
          this.achieveSavePrice = data.RebatePriceTotal
          if (data.IsPartnerOpen === '1') {
            this.isPartnerShow = true
          } else {
            this.isPartnerShow = false
          }
          this.SET_PORTRAIT_URL(data.HeadPortraitUrl)
          // 和【OrderWaitHandleNum】接口数据一样
          this.TAB_BAR_MY_BADGE(this.waitFinishBadge + this.waitReceiveBadge + this.waitEvaluateBadge)
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          }
        })
    },
    // 获取邀请好友赠送的免单卡数
    fetchRecommendCards() {
      GetRecommendSendQty().then((res) => {
        this.recommendCards = res.Msg
      })
    },
    // 获取成就模块数据
    fetchAchieveData() {
      if (this.isFetch) return
      GetMemberAchievementsInfo()
        .then((res) => {
          this.achieveData = res
          this.isFetch = true
        })
        .catch((err) => {
          if (err.ErrMsg) {
            if (err.ErrMsg) {
              Toast(err.ErrMsg)
            }
          }
        })
    },
    // 检查是否有待处理事项
    checkAnyThingToBeDone(cb) {
      // 点击限制购买跳转前判断
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      OnClickLimitCheck()
        .then((res) => {
          Indicator.close()
          if (res) {
            MessageBox({
              title: '提示',
              message: '存在待处理事项未完成，请尽快联系客服处理后，即可恢复正常购买',
              showCancelButton: true,
              confirmButtonText: '查看待处理',
              cancelButtonText: '关闭',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') this.waitHandler()
            })
          } else {
            if (cb) cb()
          }
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            if (err.ErrMsg) {
              Toast(err.ErrMsg)
            }
          }
        })
    },
    // 查看成就切换
    tiggerAchieve(val) {
      this.achieveIsOpen = val
      if (this.achieveIsOpen) this.fetchAchieveData()
    },
    // 注册
    goRegister() {
      if (this.getIsApp) {
        this.unLoginModal()
        return
      }
      this.$router.push({
        name: 'register',
        query: { recommend: '' }
      })
    },
    unLoginModal() {
      if (this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 去升级
    goUpgrade(e) {
      this.$router.push({
        name: 'memberUpgrade'
      })
    },
    // 进入违规记录页面
    goViolationPage() {
      this.limitDialogShow = false
      let currentTab = 1
      // 待办事项数
      let WaitDoneRecordCount = this.userInfo.WaitDoneRecordCount
      // 违规记录未读数
      // let UnReadCount = this.userInfo.UnReadCount
      if (Number(WaitDoneRecordCount) > 0) {
        currentTab = 0
      }
      this.$router.push({
        name: 'violationPage',
        query: { type: currentTab }
      })
    },
    // 限制标签点击
    violationTagClick() {
      // 点击限制购买跳转前判断
      this.checkAnyThingToBeDone(() => {
        this.goViolationPage()
      })
    },
    // 进入 待返余额 页面
    entoAmount() {
      this.$router.push({
        name: 'waitingRevertBalance',
        query: {
          type: 1
        }
      })
    },
    // 进入免单卡领卡中心
    freeCardCenter() {
      this.$router.push('collarCartCenter')
    },
    // 我的订单
    entoMyOrder(index) {
      if (!this.loginState) {
        Toast('请先完成登录/注册，再查看')
        return
      }
      this.$router.push({
        name: 'order',
        query: {
          tabIndex: index
        }
      })
    },
    // 已退款
    entoHasRefund() {
      if (!this.loginState) {
        Toast('请先完成登录/注册，再查看')
        return
      }
      this.$router.push('hadRefund')
    },
    // 邀请评价
    invitationEvaluate() {
      if (!this.loginState) {
        Toast('请先完成登录/注册，再查看')
        return
      }
      this.$router.push('invitationEvaluation')
    },
    // 余额提现
    balanceWithDraw() {
      // 点击提现前判断
      // if (this.userIsLimit) {
      //   this.checkAnyThingToBeDone(() => {
      //     this.limitDialogShow = true;
      //   });
      //   return;
      // }
      this.$router.push('balanceWithdraw')
    },
    // 返利说明
    rebateNote() {
      this.$router.push('rebateNote')
    },
    // 待处理事项
    waitHandler() {
      this.$router.push({
        name: 'violationPage',
        query: { type: 0 }
      })
    },
    // 平台协议
    platformProtocol() {
      this.$router.push('platformProtocol')
    },
    // 待办与违规
    violationPage() {
      this.goViolationPage()
    },
    // 联系客服
    contactCs() {
      this.limitDialogShow = false
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            linkToContactCustomerService: true
          }
        })
      } else {
        this.$router.push({
          name: 'posterDetail',
          query: {
            isContact: 1
          }
        })
      }
    },
    // 吐槽反馈
    makeComplaints() {
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            outsideLink: true,
            tempLink: 'https://support.qq.com/products/59252?'
          }
        })
      } else {
        window.location.href = 'https://support.qq.com/products/59252?'
      }
    },
    // 个人信息
    enterUserInfo() {
      if (this.getIsApp) {
        this.$router.push('appUserInfo')
        return
      }
      this.$router.push('userInfo')
    },
    enterRemindSetting() {
      this.$router.push('remindSetting')
    },
    // 关于我们
    aboutUs() {
      this.$router.push('aboutUs')
    },
    // 帮助与反馈
    helpAndFeedback() {
      this.$router.push('helpAndFeedback')
    },
    // 搜货合伙人
    entoPartner() {
      this.$router.push('partnerDetail')
    },
    // 分享好友
    shareClick() {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          pageType: 13
        }
      })
    },
    // 推荐排行
    recommendRank() {
      this.$router.push('recommendRank')
    }
  },
  beforeRouteLeave(to, from, next) {
    this.achieveIsOpen = false
    if (this.$refs['achieveRef']) this.$refs['achieveRef'].close()
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from)
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  overflow-x: hidden;
}
.my-info-box.info-slide {
  transform: translateY(245px);
}
/* 合伙人 */
.my-partner {
  margin-top: 2%;
}
.my-partner > a {
  border-bottom: 1px solid #eee;
}
.my-partner >>> .mint-cell-wrapper {
  font-size: 14px;
}
/* 真机顶部会有一条边框显示 */
.my-partner >>> .mint-cell-wrapper {
  background-image: none;
}
.my-partner >>> .mint-cell-wrapper {
  padding-left: 15px;
}
.my-partner >>> .mint-cell-text {
  font-size: 15px;
  font-weight: 700;
}
.my_tabs_partner {
  width: 100%;
  background: #fff;
  padding: 10px 10px 0 10px;
  box-sizing: border-box;
}
.my_tabs_partner .partner_img {
  width: 100%;
}
@media only screen and (device-width: 375px) and (device-height: 812px) {
  .my-info-box.info-slide {
    transform: translateY(245px);
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) {
  .my-info-box.info-slide {
    transform: translateY(245px);
  }
}
.emptyBoxOfRabbar {
  width: 100%;
  height: 57px;
  background: transparent;
}
</style>
